//import fetch from 'isomorphic-fetch';
import { serviceroot } from '../config';
import { buildBenchFromOptions } from './benhcRequestObjectBuilder';

let url = serviceroot + "api/benchPrice/getPrice";

export const benchPriceService = (brand, shape, mirrored, material,profileMaterial, measurements) => {
   
    let benchObject = buildBenchFromOptions(brand, shape, mirrored, material, profileMaterial, measurements);
    let request = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(benchObject)
    };   
    return fetch(url, request).then(response => response.text()).then(text => parseFloat(text));
}
